import { CancelAttributionType, CancelReasonType, KakaoReservationStatus } from '@models/sales-channels';

export const RESERVATION_STATUS_LABEL = {
  [KakaoReservationStatus.REQUESTED]: '예약확정대기',
  [KakaoReservationStatus.CONFIRMED]: '예약확정',
  [KakaoReservationStatus.COMPLETED]: '이용완료',
  [KakaoReservationStatus.CANCELLED]: '예약취소',
};

export const REFUND_REASON_FAULTER = {
  [CancelReasonType.PURCHASER_REQUEST]: CancelAttributionType.PURCHASER,
  [CancelReasonType.RE_BOOKING]: CancelAttributionType.PURCHASER,
  [CancelReasonType.HEALTH_REASON]: CancelAttributionType.PURCHASER,
  [CancelReasonType.THIRD_PARTY_LOWEST_PRICE]: CancelAttributionType.PURCHASER,
  [CancelReasonType.SIMPLE_REMORSE]: CancelAttributionType.PURCHASER,
  [CancelReasonType.STORE_SUSPENSION]: CancelAttributionType.PARTNER,
  [CancelReasonType.BOOKING_CLOSED]: CancelAttributionType.PARTNER,
  [CancelReasonType.SHORTAGE_OF_PURCHASERS]: CancelAttributionType.PARTNER,
  [CancelReasonType.NATURAL_DISASTER]: CancelAttributionType.ETC,
  [CancelReasonType.INFECTIOUS_DISEASE_SAFETY_RULES]: CancelAttributionType.ETC,
  [CancelReasonType.AUTO_CANCEL]: CancelAttributionType.ETC,
};
